export default __webpack_public_path__ + "static/media/methology-icon.674d95a7.png";